(function ($) {
    const locator = document.querySelector('.store-locator');

    if (!locator) {
        return;
    }

    let messages = {};

    try {
        messages = JSON.parse(locator.dataset.messages || '{}');
    } catch (e) {
        messages = {};
    }

    const searchWrap = locator.querySelector('.wpsl-search');
    const searchInput = locator.querySelector('#wpsl-search-input');
    const resultList = locator.querySelector('#wpsl-result-list');

    //== change search label ==//
    const searchLabel = locator.querySelector('#wpsl-search-wrap .wpsl-input label');
    if (searchInput && searchLabel) {
        searchInput.placeholder = searchLabel.textContent.trim();
    }
    //== change search label ==//

    //== change cat label ==//
    const catLabel = locator.querySelector('#wpsl-category label');
    const catDefaultOption = locator.querySelector('#wpsl-category select option[value="0"]');
    if (catLabel && catDefaultOption) {
        catDefaultOption.textContent = catLabel.textContent.trim();
    }
    //== change cat label ==//

    if (!searchWrap || !resultList) {
        return;
    }

    //== state UI: "use my location" button, live status, availability note ==//
    const geoButton = document.createElement('button');
    geoButton.type = 'button';
    geoButton.className = 'locator-geo-btn';
    geoButton.textContent = messages.geo_button;
    searchWrap.appendChild(geoButton);

    const status = document.createElement('div');
    status.className = 'locator-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    const note = document.createElement('p');
    note.className = 'locator-note';
    note.textContent = messages.availability_note;

    resultList.prepend(status, note);

    const STATES = ['is-loading', 'is-results', 'is-empty', 'is-not-found', 'is-error', 'is-denied'];

    // The live region stays in the DOM (empty = invisible) so screen readers announce every update
    const setStatus = (state, text) => {
        status.classList.remove(...STATES);
        status.textContent = text || '';

        if (text) {
            status.classList.add(`is-${state}`);
        }
    };

    const format = (template, data) => (template || '').replace(/\{(\w+)\}/g, (match, key) => (
        data[key] !== undefined ? data[key] : match
    ));

    const focusSearchInput = () => {
        if (searchInput) {
            searchInput.focus();
        }
    };

    // What the current search is centered on, used for {location}
    let searchOrigin = '';
    let geolocationSearchPending = false;

    //== track plugin store search requests ==//
    const getSearchParams = (settings) => {
        if (!settings || !settings.url || settings.url.indexOf('store_search') === -1) {
            return null;
        }

        return new URLSearchParams(settings.url.split('?')[1] || '');
    };

    const getRadiusLabel = (params) => {
        const radius = params.get('search_radius');
        const unit = (window.wpslSettings && window.wpslSettings.distanceUnit) || '';

        return radius ? `${radius} ${unit}`.trim() : '';
    };

    $(document).ajaxSend((event, xhr, settings) => {
        if (getSearchParams(settings)) {
            if (geolocationSearchPending) {
                searchOrigin = messages.your_location;
                geolocationSearchPending = false;
            } else {
                searchOrigin = searchInput ? searchInput.value.trim() : '';
            }

            resultList.setAttribute('aria-busy', 'true');
            setStatus('loading', messages.loading);
        }
    });

    $(document).ajaxSuccess((event, xhr, settings, response) => {
        const params = getSearchParams(settings);

        if (!params) {
            return;
        }

        resultList.removeAttribute('aria-busy');

        const count = Array.isArray(response) ? response.length : 0;
        const data = {
            count,
            radius: getRadiusLabel(params),
            location: searchOrigin || messages.your_location,
        };

        if (params.get('autoload') === '1') {
            setStatus('results', count ? format(messages.results_default, data) : '');
        } else if (count) {
            setStatus('results', format(messages.results, data));
        } else {
            setStatus('empty', format(messages.empty, data));
        }
    });

    $(document).ajaxError((event, xhr, settings) => {
        if (!getSearchParams(settings)) {
            return;
        }

        resultList.removeAttribute('aria-busy');
        // The plugin has no error handler, so its preloader would spin forever
        $(locator).find('.wpsl-preloader').remove();
        setStatus('error', messages.error);
    });

    //== geolocation with explicit denied / timeout / unavailable states ==//
    let allowPluginGeolocation = false;

    const runPluginGeolocation = () => {
        // The plugin's own map control requests the (now cached) position and runs the search
        const pluginButton = locator.querySelector('.wpsl-icon-direction');

        if (!pluginButton) {
            setStatus('error', messages.unavailable);
            return;
        }

        geolocationSearchPending = true;
        allowPluginGeolocation = true;
        $(pluginButton).trigger('click');
        allowPluginGeolocation = false;
    };

    const onGeolocationError = (error) => {
        geoButton.removeAttribute('aria-busy');

        if (error && error.code === 1) {
            setStatus('denied', messages.denied);
        } else {
            setStatus('denied', messages.unavailable);
        }

        focusSearchInput();
    };

    const locateUser = () => {
        if (!navigator.geolocation) {
            onGeolocationError(null);
            return;
        }

        const timeout = Number((window.wpslSettings && window.wpslSettings.geoLocationTimeout) || 7500);

        geoButton.setAttribute('aria-busy', 'true');
        setStatus('loading', messages.locating);

        const request = () => {
            /*
             * The browser timeout only starts after permission is granted, so an ignored
             * permission prompt would keep "locating" forever. Show the manual-entry fallback
             * instead; a late approval still runs the search.
             */
            const watchdog = setTimeout(() => onGeolocationError({code: 3}), timeout);

            navigator.geolocation.getCurrentPosition(() => {
                clearTimeout(watchdog);
                geoButton.removeAttribute('aria-busy');
                runPluginGeolocation();
            }, (error) => {
                clearTimeout(watchdog);
                onGeolocationError(error);
            }, {
                // Same options as the plugin, so its follow-up request reuses this cached position
                enableHighAccuracy: true,
                maximumAge: 60000,
                timeout,
            });
        };

        if (navigator.permissions && navigator.permissions.query) {
            navigator.permissions.query({name: 'geolocation'}).then((result) => {
                if (result.state === 'denied') {
                    onGeolocationError({code: 1});
                } else {
                    request();
                }
            }, request);
        } else {
            request();
        }
    };

    geoButton.addEventListener('click', locateUser);

    // Route the plugin's map control through the same flow (it reports errors with alert())
    document.addEventListener('click', (event) => {
        if (allowPluginGeolocation || !event.target.closest('.store-locator .wpsl-icon-direction')) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        locateUser();
    }, true);

    //== "location not found" vs "no stores found" ==//
    /*
     * With the country restriction Google never answers ZERO_RESULTS for an unknown or foreign
     * place ("Kyiv" on the US site, typos): it returns the whole country as a partial match.
     * Report that as "not found" so the plugin takes its geocode-error path (handled below),
     * instead of searching around the country's centre and showing "No stores found".
     */
    const isCountryFallback = (results) => {
        const first = results && results[0];

        return !!(first && first.partial_match && first.types && first.types.indexOf('country') !== -1);
    };

    const patchGeocoder = () => {
        const Geocoder = window.google && window.google.maps && window.google.maps.Geocoder;

        if (!Geocoder) {
            return false;
        }

        const proto = Geocoder.prototype;

        if (proto.bobSnailPatched) {
            return true;
        }

        const originalGeocode = proto.geocode;

        proto.geocode = function (request, callback) {
            const restricted = request && request.componentRestrictions && request.componentRestrictions.country;

            if (!restricted || typeof callback !== 'function') {
                return originalGeocode.apply(this, arguments);
            }

            return originalGeocode.call(this, request, (results, geocodeStatus) => {
                if (geocodeStatus === 'OK' && isCountryFallback(results)) {
                    callback([], 'ZERO_RESULTS');
                    return;
                }

                callback(results, geocodeStatus);
            });
        };

        proto.bobSnailPatched = true;

        return true;
    };

    // Google Maps loads asynchronously after this bundle
    if (!patchGeocoder()) {
        let attempts = 0;
        const waitForMaps = setInterval(() => {
            attempts++;

            if (patchGeocoder() || attempts > 150) {
                clearInterval(waitForMaps);
            }
        }, 200);
    }

    //== show the plugin's alert() errors inline instead of a blocking dialog ==//
    // Read lazily: the plugin's localized labels are printed after this bundle
    const getAlertState = (text) => {
        const labels = window.wpslLabels || {};
        const geoErrors = window.wpslGeolocationErrors || {};
        const map = [
            // Geocoder ZERO_RESULTS reuses the "no results" label: the typed address was not found
            [labels.noResults, 'not-found', messages.address_not_found],
            [labels.generalError, 'error', messages.error],
            [labels.queryLimit, 'error', messages.error],
            [labels.noDirectionsFound, 'error', labels.noDirectionsFound],
            [geoErrors.denied, 'denied', messages.denied],
            [geoErrors.unavailable, 'denied', messages.unavailable],
            [geoErrors.timeout, 'denied', messages.unavailable],
            [geoErrors.generalError, 'denied', messages.unavailable],
        ].find(([label]) => label && label === text);

        return map ? {state: map[1], message: map[2]} : null;
    };

    const nativeAlert = window.alert;

    window.alert = function (text) {
        const mapped = getAlertState(text);

        if (!mapped) {
            return nativeAlert.apply(window, arguments);
        }

        resultList.removeAttribute('aria-busy');
        $(locator).find('.wpsl-preloader').remove();
        setStatus(mapped.state, format(mapped.message, {
            location: searchInput ? searchInput.value.trim() : '',
        }));

        if (mapped.state === 'denied' || mapped.state === 'not-found') {
            focusSearchInput();
        }
    };
})(jQuery);
